export const handleUnexpectedResourceAccess = ({
  errorMessage,
  onMatchedError,
  onAnyOtherError,
}: {
  errorMessage: string;
  onMatchedError: () => void;
  onAnyOtherError: () => void;
}) => {
  handleSpecificRainbowError({
    errorMessage,
    errorMatcher: {type: 'unexpected', name: 'resource_access'},
    onMatchedError,
    onAnyOtherError,
  });
};

const handleSpecificRainbowError = ({
  errorMessage,
  errorMatcher: {type, name},
  onMatchedError,
  onAnyOtherError,
}: {
  errorMessage: string;
  errorMatcher: {
    type: string;
    name: string;
  };
  onMatchedError: () => void;
  onAnyOtherError: () => void;
}) => {
  try {
    const parsedError: {
      type: string;
      name: string;
      message: string;
    } = JSON.parse(errorMessage);
    if (parsedError.type === type && parsedError.name === name) {
      onMatchedError();
    } else {
      onAnyOtherError();
    }
  } catch {
    onAnyOtherError();
  }
};
